import { useMemo } from 'react';
import { useBuilderStore } from '../store/builderStore';
import { calculatePrice } from '@printtat/shared';
import type { PriceBreakdown } from '@printtat/shared';

export function usePricing(): PriceBreakdown | null {
  const surfaces = useBuilderStore((s) => s.surfaces);
  const pricingConfig = useBuilderStore((s) => s.pricingConfig);
  const dimensions = useBuilderStore((s) => s.productConfig.dimensions);
  const surfaceOptionSelections = useBuilderStore((s) => s.surfaceOptionSelections);
  const basePrice = useBuilderStore((s) => s.basePrice);

  return useMemo(() => {
    if (!pricingConfig) return null;
    return calculatePrice(
      pricingConfig,
      surfaces,
      dimensions,
      surfaceOptionSelections,
      basePrice,
      0, // variantAdditionalPrice — variant selection not yet in builder
    );
  }, [pricingConfig, surfaces, dimensions, surfaceOptionSelections, basePrice]);
}
